import React from "react";
export default function AddImageIcon(props) {
  return (
    <div class="upload-btn-wrapper">
      <button class="primary">Upload image</button>
      <input type="file" accept="image/png, image/jpeg" 
        multiple
        onChange = {(e) => props.onChange(e.target.files)}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/MeetingNote/AddImageIcon/index.js